import { LoanEditorActionsEnum } from 'constants/loanActionEditor';
import { DEFAULT_LOAN_ACTION_TARGET_TYPE, LoanActionTargetType } from 'constants/loanActions';
import { getConditionalArray } from 'utils/data';

const getApplicationActionTypeOptions = ({
  isSavePendingChangesLoanActionEnabled,
  isCustomFormsViewAllowed = true,
}) => [
  {
    name: 'Assign Task',
    value: LoanEditorActionsEnum.ASSIGN_TASK,
    isSingleEntity: true,
  },
  {
    name: 'Set application value',
    value: LoanEditorActionsEnum.SET_FIELD_STATIC,
  },
  {
    name: 'Loan Editor Fields',
    value: LoanEditorActionsEnum.SET_FIELD_DYNAMIC,
  },
  {
    name: 'Add tag',
    value: LoanEditorActionsEnum.ADD_TAG,
  },
  {
    name: 'Remove tag',
    value: LoanEditorActionsEnum.REMOVE_TAG,
  },
  {
    name: 'Generate/Print form',
    value: LoanEditorActionsEnum.GENERATE_FORM,
  },
  {
    name: 'Generate/Print PDF',
    value: LoanEditorActionsEnum.GENERATE_PDF,
    isSingleEntity: true,
  },
  {
    name: 'Send form',
    value: LoanEditorActionsEnum.SEND_FORM,
  },
  {
    name: 'Send form bundle',
    value: LoanEditorActionsEnum.SEND_FORM_BUNDLE,
  },
  {
    name: 'Impersonate as Borrower',
    value: LoanEditorActionsEnum.IMPERSONATE_AS_BORROWER,
    isSingleEntity: true,
  },
  {
    name: 'Order/Update Report',
    value: LoanEditorActionsEnum.ORDER_UPDATE_REPORT_MANUAL,
  },
  {
    name: 'Generate Checklist',
    value: LoanEditorActionsEnum.GENERATE_CHECKLIST,
  },
  {
    name: 'Create/download MISMO',
    value: LoanEditorActionsEnum.CREATE_AND_DOWNLOAD_MISMO_FILE,
    isSingleEntity: true,
  },
  {
    name: 'Export Loan Package',
    value: LoanEditorActionsEnum.EXPORT_LOAN_PACKAGE,
    isSingleEntity: true,
  },
  {
    name: 'Lock Loan',
    value: LoanEditorActionsEnum.LOCK_LOAN,
    isSingleEntity: true,
  },
  {
    name: 'Run AUS',
    value: LoanEditorActionsEnum.RUN_AUS,
    isSingleEntity: true,
  },
  {
    name: 'Select AUS Provider',
    value: LoanEditorActionsEnum.SELECT_AUS_PROVIDER,
    isSingleEntity: true,
  },
  {
    name: 'Assign Loan Role',
    value: LoanEditorActionsEnum.ASSIGN_LOAN_ROLE,
    isSingleEntity: true,
  },
  {
    name: 'Unassign Loan Role',
    value: LoanEditorActionsEnum.UNASSIGN_LOAN_ROLE,
    isSingleEntity: true,
  },
  {
    name: 'Finalize DO',
    value: LoanEditorActionsEnum.FINALIZE_DO,
    isSingleEntity: true,
  },
  {
    name: 'Submit UCD',
    value: LoanEditorActionsEnum.SUBMIT_UCD,
    isSingleEntity: true,
  },
  {
    name: 'Reset Findings',
    value: LoanEditorActionsEnum.RESET_AUS_FINDINGS,
    isSingleEntity: true,
  },
  {
    name: 'Convert Lead to Loan',
    value: LoanEditorActionsEnum.CONVERT_LEAD_TO_LOAN,
    isSingleEntity: true,
  },
  {
    name: 'Submit Application',
    value: LoanEditorActionsEnum.SUBMIT_APPLICATION,
    isSingleEntity: true,
  },
  {
    name: 'Send Email',
    value: LoanEditorActionsEnum.SEND_EMAIL_TEMPLATE,
    isSingleEntity: true,
  },
  {
    name: 'Grant Closing Portal Access',
    value: LoanEditorActionsEnum.GRANT_CLOSING_PORTAL_ACCESS,
    isSingleEntity: true,
  },
  {
    name: 'Set application impound',
    value: LoanEditorActionsEnum.SET_APPLICATION_IMPOUND,
    isSingleEntity: true,
  },
  {
    name: 'Run FHA Service',
    value: LoanEditorActionsEnum.RUN_FHA_SERVICE,
    isSingleEntity: true,
  },
  {
    name: 'Run VA Service',
    value: LoanEditorActionsEnum.RUN_VA_SERVICE,
    isSingleEntity: true,
  },
  {
    name: 'Run Appraisal Service',
    value: LoanEditorActionsEnum.RUN_APPRAISAL_SERVICE,
    isSingleEntity: true,
  },
  {
    name: 'Run Appraisal Service QC',
    value: LoanEditorActionsEnum.RUN_APPRAISAL_SERVICE_QC,
    isSingleEntity: true,
  },
  {
    name: 'Run Flood Service',
    value: LoanEditorActionsEnum.RUN_FLOOD_SERVICE,
    isSingleEntity: true,
  },
  {
    name: 'Update Flood Order',
    value: LoanEditorActionsEnum.UPDATE_FLOOD_DETERMINATION,
    isSingleEntity: true,
  },
  {
    name: 'Register with MERS',
    value: LoanEditorActionsEnum.REGISTER_WITH_MERS,
    isSingleEntity: true,
  },
  {
    name: 'Deactivate MIN with MERS',
    value: LoanEditorActionsEnum.DEACTIVATE_MERS_MIN,
    isSingleEntity: true,
  },
  {
    name: 'Reverse MERS Deactivation',
    value: LoanEditorActionsEnum.REVERSE_MERS_DEACTIVATION,
    isSingleEntity: true,
  },
  {
    name: 'Transfer with MERS',
    value: LoanEditorActionsEnum.TRANSFER_WITH_MERS,
    isSingleEntity: true,
  },
  {
    name: 'Preview MERS',
    value: LoanEditorActionsEnum.PREVIEW_MERS,
    isSingleEntity: true,
  },
  {
    name: 'Order Mortgage Insurance',
    value: LoanEditorActionsEnum.ORDER_MORTGAGE_INSURANCE,
    isSingleEntity: true,
  },
  {
    name: 'Check Mortgage Insurance Status',
    value: LoanEditorActionsEnum.CHECK_MORTGAGE_INSURANCE_STATUS,
    isSingleEntity: true,
  },
  {
    name: 'Activate Mortgage Insurance',
    value: LoanEditorActionsEnum.ACTIVATE_MORTGAGE_INSURANCE,
    isSingleEntity: true,
  },
  {
    name: 'Resend Borrower Data',
    value: LoanEditorActionsEnum.RETRY_HALCYON_ORDER,
    isSingleEntity: true,
  },
  {
    name: 'Resend Halcyon Authorization',
    value: LoanEditorActionsEnum.RESEND_HALCYON_AUTHORIZATION,
    isSingleEntity: true,
  },
  {
    name: 'Resend Halcyon Consent Documents',
    value: LoanEditorActionsEnum.RESEND_HALCYON_CONSENT_DOCUMENTS,
    isSingleEntity: true,
  },
  {
    name: 'Cancel Halcyon Order',
    value: LoanEditorActionsEnum.CANCEL_HALCYON_ORDER,
    isSingleEntity: true,
  },
  {
    name: 'Add Halcyon Transcript Forms',
    value: LoanEditorActionsEnum.ADD_HALCYON_TRANSCRIPT_FORMS,
    isSingleEntity: true,
  },
  ...getConditionalArray(isCustomFormsViewAllowed, () => [
    {
      name: 'Open Loan Editor Form',
      value: LoanEditorActionsEnum.OPEN_LOAN_EDITOR_FORM,
      isSingleEntity: true,
    },
  ]),
  {
    name: 'Open URL in Iframe',
    value: LoanEditorActionsEnum.OPEN_URL_IN_IFRAME,
    isSingleEntity: true,
  },
  {
    name: 'Select Program/Rate',
    value: LoanEditorActionsEnum.OPEN_PROGRAM_SELECTION,
    isSingleEntity: true,
  },
  {
    name: 'Import MISMO into Loan',
    value: LoanEditorActionsEnum.IMPORT_MISMO_TO_LOAN,
    isSingleEntity: true,
  },
  {
    name: 'Enter Custom Fields',
    value: LoanEditorActionsEnum.ENTER_CUSTOM_FIELDS,
    isSingleEntity: true,
  },
  {
    name: 'Generate Compliance Review Report',
    value: LoanEditorActionsEnum.GENERATE_COMPLIANCE_REPORT,
    isSingleEntity: true,
  },
  {
    name: 'Run Compliance Audit',
    value: LoanEditorActionsEnum.RUN_COMPLIANCE_AUDIT,
    isSingleEntity: true,
  },
  {
    name: 'Create Document from Source',
    value: LoanEditorActionsEnum.CREATE_DOCUMENT_FROM_SOURCE,
    isSingleEntity: true,
  },
  {
    name: 'Set Form Bundle Readiness Status',
    value: LoanEditorActionsEnum.SET_FORM_BUNDLE_READINESS_STATUS,
    isSingleEntity: true,
  },
  {
    name: 'Set Form Delivery Sent Date',
    value: LoanEditorActionsEnum.SET_FORM_DELIVERY_SENT_DATE,
    isSingleEntity: true,
  },
  {
    name: 'Move Back One Milestone',
    value: LoanEditorActionsEnum.MOVE_BACK_MILESTONE,
    isSingleEntity: true,
  },
  {
    name: 'Refresh credit events',
    value: LoanEditorActionsEnum.REFRESH_CREDIT_EVENTS,
    isSingleEntity: true,
  },
  {
    name: 'Mail Document Package',
    value: LoanEditorActionsEnum.MAIL_DOCUMENT_PACKAGE,
    isSingleEntity: true,
  },
  {
    name: 'Upload Form Delivery',
    value: LoanEditorActionsEnum.UPLOAD_FORM_DELIVERY,
    isSingleEntity: true,
  },
  {
    name: 'Request Argyle Verification',
    value: LoanEditorActionsEnum.REQUEST_ARGYLE_VERIFICATION,
    isSingleEntity: true,
  },
  {
    name: 'Request Finicity Verification',
    value: LoanEditorActionsEnum.REQUEST_FINICITY_VERIFICATION,
    isSingleEntity: true,
  },
  // Not `isSingleEntity`: unlike Grant Closing Portal Access, this action authors a LIST of
  // permission rows (one expression + Cancel/Save grants each), so the multi-entity "+" add
  // affordance must stay available.
  ...getConditionalArray(isSavePendingChangesLoanActionEnabled, [
    {
      name: 'Save Pending Changes',
      value: LoanEditorActionsEnum.SAVE_PENDING_CHANGES,
    },
  ]),
  {
    name: 'Run Loan Calculations',
    value: LoanEditorActionsEnum.RUN_LOAN_CALCULATIONS,
    isSingleEntity: true,
  },
  {
    name: 'Call Integration',
    value: LoanEditorActionsEnum.CALL_INTEGRATION,
    isSingleEntity: true,
  },
  {
    name: 'Run AI Process',
    value: LoanEditorActionsEnum.RUN_AI_PROCESS,
    isSingleEntity: true,
  },
  {
    name: 'Send AI results to connector',
    value: LoanEditorActionsEnum.SEND_AI_PROCESS_RESULTS,
    isSingleEntity: true,
  },
  {
    name: 'Send Closing to SnapDocs',
    value: LoanEditorActionsEnum.SEND_CLOSING_TO_SNAPDOCS,
    isSingleEntity: true,
  },
  {
    name: 'Full Redraw SnapDocs Closing',
    value: LoanEditorActionsEnum.FULL_REDRAW_SNAPDOCS_CLOSING,
    isSingleEntity: true,
  },
  {
    name: 'Cancel SnapDocs Closing',
    value: LoanEditorActionsEnum.CANCEL_SNAPDOCS_CLOSING,
    isSingleEntity: true,
  },
  {
    name: 'Complete SnapDocs Closing',
    value: LoanEditorActionsEnum.COMPLETE_SNAPDOCS_CLOSING,
    isSingleEntity: true,
  },
  {
    name: 'Partial Redraw SnapDocs Closing',
    value: LoanEditorActionsEnum.PARTIAL_REDRAW_SNAPDOCS_CLOSING,
    isSingleEntity: true,
  },
  {
    name: 'Reopen SnapDocs Closing',
    value: LoanEditorActionsEnum.REOPEN_SNAPDOCS_CLOSING,
    isSingleEntity: true,
  },
  {
    name: 'Update SnapDocs Appointment',
    value: LoanEditorActionsEnum.UPDATE_SNAPDOCS_APPOINTMENT,
    isSingleEntity: true,
  },
  {
    name: 'Convert SnapDocs Signing Method',
    value: LoanEditorActionsEnum.CONVERT_SNAPDOCS_SIGNING_METHOD,
    isSingleEntity: true,
  },
  {
    name: 'Request SnapDocs Notary',
    value: LoanEditorActionsEnum.REQUEST_SNAPDOCS_NOTARY,
    isSingleEntity: true,
  },
  {
    name: 'Post SnapDocs Comment',
    value: LoanEditorActionsEnum.POST_SNAPDOCS_COMMENT,
    isSingleEntity: true,
  },
  {
    name: 'Opt In to SnapDocs eSigning',
    value: LoanEditorActionsEnum.OPT_IN_SNAPDOCS_ESIGNING,
    isSingleEntity: true,
  },
  {
    name: 'Opt Out of SnapDocs eSigning',
    value: LoanEditorActionsEnum.OPT_OUT_SNAPDOCS_ESIGNING,
    isSingleEntity: true,
  },
];

const contactOnlyActionTypeOptions = [
  {
    name: 'Send SMS',
    value: LoanEditorActionsEnum.SEND_SMS_TEMPLATE,
    isSingleEntity: true,
  },
  {
    name: 'Send Push Notification',
    value: LoanEditorActionsEnum.SEND_PUSH_TEMPLATE,
    isSingleEntity: true,
  },
  {
    name: 'Assign Contact Owner',
    value: LoanEditorActionsEnum.ASSIGN_CONTACT_OWNER,
    isSingleEntity: true,
  },
  {
    name: 'Log Contact Activity',
    value: LoanEditorActionsEnum.LOG_CONTACT_ACTIVITY,
    isSingleEntity: true,
  },
];

const subCompanyOnlyActionTypeOptions = [
  {
    name: 'Assign Account Executive',
    value: LoanEditorActionsEnum.ASSIGN_SUB_COMPANY_AE,
    isSingleEntity: true,
  },
  {
    name: 'Decide Certification',
    value: LoanEditorActionsEnum.DECIDE_CERTIFICATION,
    isSingleEntity: true,
  },
  {
    name: 'Start Certification Cycle',
    value: LoanEditorActionsEnum.START_CERTIFICATION_CYCLE,
    isSingleEntity: true,
  },
  {
    name: 'Execute AI Process',
    value: LoanEditorActionsEnum.EXECUTE_AI_PROCESS,
    isSingleEntity: true,
  },
];

const CONTACT_ACTION_TYPE_WHITELIST = new Set([
  LoanEditorActionsEnum.ADD_TAG,
  LoanEditorActionsEnum.REMOVE_TAG,
  LoanEditorActionsEnum.SEND_EMAIL_TEMPLATE,
  LoanEditorActionsEnum.SEND_SMS_TEMPLATE,
  LoanEditorActionsEnum.SEND_PUSH_TEMPLATE,
  LoanEditorActionsEnum.ASSIGN_CONTACT_OWNER,
  LoanEditorActionsEnum.LOG_CONTACT_ACTIVITY,
]);

// OPEN_URL_IN_IFRAME is intentionally excluded: the backend's SubCompanyValidActionTypes
// (LoanActionTargetCompatibility) does not list it, so a config carrying it is dropped
// wholesale by the multi-item compatibility rule and would silently never surface (matches
// the Contact whitelist's precedent, which also excludes it).
const SUB_COMPANY_ACTION_TYPE_WHITELIST = new Set([
  LoanEditorActionsEnum.ASSIGN_TASK,
  LoanEditorActionsEnum.ASSIGN_SUB_COMPANY_AE,
  LoanEditorActionsEnum.SEND_EMAIL_TEMPLATE,
  LoanEditorActionsEnum.DECIDE_CERTIFICATION,
  LoanEditorActionsEnum.START_CERTIFICATION_CYCLE,
  LoanEditorActionsEnum.EXECUTE_AI_PROCESS,
]);

const actionTypeWhitelistByTarget = {
  [LoanActionTargetType.CONTACT]: CONTACT_ACTION_TYPE_WHITELIST,
  [LoanActionTargetType.SUB_COMPANY]: SUB_COMPANY_ACTION_TYPE_WHITELIST,
};

export const getLoanEditorActionTypeOptions = ({
  targetType = DEFAULT_LOAN_ACTION_TARGET_TYPE,
  isSavePendingChangesLoanActionEnabled,
  isCustomFormsViewAllowed = true,
}) => {
  const applicationOptions = getApplicationActionTypeOptions({
    isSavePendingChangesLoanActionEnabled,
    isCustomFormsViewAllowed,
  });

  if (targetType === LoanActionTargetType.APPLICATION) {
    return applicationOptions;
  }

  const whitelist = actionTypeWhitelistByTarget[targetType];

  if (!whitelist) {
    return applicationOptions;
  }

  return [
    ...applicationOptions,
    ...contactOnlyActionTypeOptions,
    ...subCompanyOnlyActionTypeOptions,
  ].filter(({ value }) => whitelist.has(value));
};
